<template>
  <div class="full-size">
    <div class="full-size leaderboard-wrap-v2" :class="{'light': !isTextColourLight}">
      <div class="leaderboard-overlay" @click="closeLeaderboard"></div>
      <div
        :class="`leaderboard-popup ${type}`"
      >
        <span @click="closeLeaderboard" class="leaderboard-close">
          <aha-icon-button :variant="isTextColourLight ? `tertiary-dark` : 'tertiary'">
            <aha-icon
              name="close-v2"
              height="24"
              width="24"
              viewBox="0 0 16 16"
            />
          </aha-icon-button>
        </span>

        <LeaderboardTitle />

        <LeaderboardNumberOfPlayers
          :rankingListCount="rankingListCount"
          :isShowingTeamList="isShowingTeamList"
          :displayedNumberOfPlayers="displayedNumberOfPlayers"
        />

        <LeaderboardLoader v-if="loading" />

        <div
          class="leaderboard-ranking-list"
          ref="leaderboard-ranking-list"
          @scroll="handleScrollLeaderboard"
          v-else
        >
          <div class="leaderboard--content-v2 vertical layout">
            <div
              v-if="!noData"
              id="top-audience-quiz-v2"
              class="top-audience"
            >
              <div
                class="box-audience-list"
                :class="{'horizontal layout center': rankingList?.length < minNumberOfDisplayedPlayer}"
              >
                <transition-group
                  name="leaderboard"
                  tag="ul"
                  class="box-audience-wrapper"
                  style="padding-left: 0; width: 100%;"
                >
                  <li
                    v-for="(item,index) in listAudienceShow"
                    :key="rankingListKey(item)"
                    class="audience--item horizontal layout center"
                    :class="{'final-animation': index == 0 && finalSlide}"
                  >
                    <div
                      class="audience--rank"
                      :class="{'visible': isAudienceRankVisible}"
                    >
                      <span class="audience--rank-wrapper">
                        <span
                          class="audience--rank-circle"
                        />
                        <span class="audience--rank-text font-weight-bold">{{ item.index }}</span>
                      </span>
                    </div>
                    <div
                      class="audience--bar"
                      :class="{'dark-theme': isTextColourLight}"
                    >
                      <!-- Color bar layer 2-->
                      <div
                        class="audience--bar-progress layer--2"
                        :style="{'width': `${item.oldPercent}%`, 'background-color': getBarColor(item)}"
                        :class="{'animation': animation, 'has-leaderboard-swap': isNextLeaderboard}"
                      >
                        <div class="px-3 audience--bar-info layer--1">
                          <div class="bar--name">
                            <div class="player-name">
                              <span class="player-name__text">
                                <span class="pr-1 bar--emoji" v-if="isShownEmojiAvatar && item.audienceEmoji">
                                  <span>{{ item.audienceEmoji }}</span>
                                </span>
                                <span v-if="canFilterProfanity(item)" class="font-weight-bold">
                                  {{ getItemName(item) | profanity }}
                                </span>
                                <span v-else class="font-weight-bold">
                                  {{ item.isCensorName ? item.censorName : item.audienceName }}
                                </span>
                              </span>

                              <span v-if="canModifyLeaderboard" class="ml-3 action">
                                <span class="mr-2" @click="addManualPoints(item)">
                                  <i
                                    class="fas fa-arrow-alt-circle-up"
                                  />
                                  {{ $t('points') }}
                                </span>

                                <span v-if="!isShowingTeamList" @click="addCensorName(item)">
                                  <i
                                    class="fas"
                                    :class="item.isCensorName ?
                                      'fa-eye' : 'fa-eye-slash'"
                                  />
                                  {{ $t('name') }}
                                </span>
                                <ButtonStartVoice
                                  v-if="item.audience"
                                  class="button-voice"
                                  :audienceUnique="item.audience"
                                  :audienceName="item.audienceName"
                                />
                              </span>
                            </div>
                            <div class="team-member" v-if="isShowingTeamList">
                              <span
                                v-for="(member, indexMember) in item.members"
                                v-show="indexMember < 10"
                                :key="indexMember"
                              >
                                <span v-if="isShownEmojiAvatar" class="mr-1">{{ member.audienceEmoji | trim }}</span>
                                <span>{{ member.audienceName | trim | profanity }}</span>
                                <span v-if="indexMember < item.members.length - 1">, </span>
                              </span>
                              <span
                                v-if="item?.members?.length - 10 > 0"
                              >+ {{ item?.members?.length - 10 }}</span>
                            </div>
                            <div v-if="isTeamPlay && isShowingIndividualLeaderboardForTeamPlay" class="team-name">
                              <span>{{ getTeamName(item) }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Audience info layer 3 -->
                      <div class="px-3 audience--bar-info layer--3">
                        <div class="bar--name">
                          <div class="player-name">
                            <span class="player-name__text">
                              <span class="pr-2 bar--emoji" v-if="item.audienceEmoji && isShownEmojiAvatar">
                                <span>{{ item.audienceEmoji }}</span>
                              </span>
                              <span v-if="canFilterProfanity(item)" class="font-weight-bold">
                                {{ getItemName(item) | profanity }}
                              </span>
                              <span v-else class="font-weight-bold">
                                {{ item.isCensorName ? item.censorName: item.audienceName }}
                              </span>
                            </span>

                            <span v-if="canModifyLeaderboard" class="ml-3 action">
                              <span class="mr-2" @click="addManualPoints(item)">
                                <i
                                  class="fas fa-arrow-alt-circle-up"
                                />
                                {{ $t('points') }}
                              </span>

                              <span v-if="!isShowingTeamList" @click="addCensorName(item)">
                                <i
                                  class="fas"
                                  :class="item.isCensorName ?
                                    'fa-eye' : 'fa-eye-slash'"
                                />
                                {{ $t('name') }}
                              </span>
                              <ButtonStartVoice
                                v-if="item.audience"
                                class="button-voice"
                                :audienceUnique="item.audience"
                                :audienceName="item.audienceName"
                              />
                            </span>
                          </div>
                          <div class="team-member" v-if="isShowingTeamList">
                            <span
                              v-for="(member, indexMember) in item.members"
                              v-show="indexMember < 10"
                              :key="indexMember"
                            >
                              <span v-if="isShownEmojiAvatar" class="mr-1">{{ member.audienceEmoji | trim }}</span>
                              <span>{{ member.audienceName | trim | profanity }}</span>
                              <span v-if="indexMember < item.members.length - 1">, </span>
                            </span>
                            <span
                              v-if="item?.members?.length - 10 > 0"
                            >+ {{ item?.members?.length - 10 }}</span>
                          </div>
                          <div v-if="isTeamPlay && isShowingIndividualLeaderboardForTeamPlay" class="team-name">
                            <span>{{ getTeamName(item) }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="audience--points horizontal layout end">
                      <CountPointLeaderboard
                        :old-point="item.oldPoint || 0"
                        :total-point="item.totalPoint"
                        :has-leaderboard-swap="isNextLeaderboard"
                      />
                    </div>
                  </li>
                </transition-group>
              </div>
            </div>

            <div v-if="noData" class="no-data horizontal layout center center-justified">
              <div>
                <strong class="quiz--result font-weight-bold">{{ $t("noResultYet") }}</strong>
                <p class="quiz--result-desc">
                  {{ $t("theTopQuizPlayer") }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="scrollShow && !loading && !noData"
          class="pt-1 arrow-grid animate__animated animate__flash animate__slow animate__delay-5s"
          :class="{'disabled': scrollDisable}"
        >
          <aha-icon-button
            :variant="isTextColourLight ? `tertiary-dark` : 'tertiary'"
            @click="scrollBottom"
          >
            <aha-icon
              name="chevron-down-new"
              width="24"
              height="24"
              viewBox="0 0 12 12"
            />
          </aha-icon-button>
        </div>
        <LeaderboardInstructions
          :showCarousel="showCarousel"
          :showWinner="showWinner"
          :finalSlide="finalSlide"
          :isShowingIndividualLeaderboardForTeamPlay="isShowingIndividualLeaderboardForTeamPlay"
          :isTeamPlay="isTeamPlay"
        />
        <LeaderboardWinner
          :rankingList="rankingList"
          :countWinner="countWinner"
          :topWinnerStr="topWinnerStr"
          :timeRunbanner="timeRunbanner"
          :showCarousel="showCarousel"
          :showWinner="showWinner"
          :showEmoji="isShownEmojiAvatar"
          :isShowingTeamList="isShowingTeamList"
          :fontSizeMemberWinner="fontSizeMemberWinner"
          :loading="loading"
        />
      </div>
    </div>

    <LeaderboardManualPointPopup
      v-if="addPointVisible"
      :data="addPointData"
      :audiences="listAudienceShow"
      @ok="addPointOk"
      @close="addPointClose"
    />
  </div>
</template>
<script>
import confetti from 'canvas-confetti'
import * as Sentry from '@sentry/vue'
import { mapActions, mapState, mapGetters } from 'vuex'
import Constant from '@/constant'
import Util from '@/util'
import EventBus from '@/eventBus'
import config from '@/config'
import CountPointLeaderboard from '@/components/presentations/CountPointLeaderboard.vue'
import LeaderboardManualPointPopup from '@/components-v2/leaderboard/LeaderboardManualPointPopup.vue'
import LeaderboardWinner from '@/components-v2/leaderboard/LeaderboardWinner.vue'
import LeaderboardTitle from '@/components-v2/leaderboard/LeaderboardTitle.vue'
import LeaderboardLoader from '@/components-v2/leaderboard/LeaderboardLoader.vue'
import LeaderboardNumberOfPlayers from '@/components-v2/leaderboard/LeaderboardNumberOfPlayers.vue'
import LeaderboardInstructions from '@/components-v2/leaderboard/LeaderboardInstructions.vue'
import LeaderboardMixin from '@/components/presentations/contents/LeaderboardMixin.vue'

import ButtonStartVoice from '@/components-v2/voice-audio/ButtonStartVoice.vue'

const LEADERBOARD_RANKING_LIST_REF = 'leaderboard-ranking-list'

export default {
  components: {
    CountPointLeaderboard,
    LeaderboardManualPointPopup,
    ButtonStartVoice,
    LeaderboardLoader,
    LeaderboardWinner,
    LeaderboardTitle,
    LeaderboardNumberOfPlayers,
    LeaderboardInstructions,
  },
  mixins: [LeaderboardMixin],
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: true,
      topAudiences: [],
      animation: false,
      noData: false,
      finalSlide: false,
      showWinner: false,
      topWinnerStr: '',
      countWinner: null,
      myReq: null,
      timeOut1: null,
      timeOut2: null,
      timeOut3: null,
      scrollShow: true,
      scrollDisable: false,
      listAudienceShow: [],
      blockAudiences: [],
      timeRunbanner: '',
      minNumberOfDisplayedPlayer: 10,
      teams: {},
      addPointData: {},
      addPointVisible: false,
      fontSizeMemberWinner: null,
      showCarousel: false,
    }
  },
  computed: {
    ...mapGetters('leaderboard', [
      'isLeaderboardVisible',
      'leaderboardData',
      'isTeamPlay',
      'isShowingIndividualLeaderboardForTeamPlay',
      'rankingList',
      'rankingListCount',
      'rankingListKey',
      'getItemName',
      'isShowingTeamList',
      'getPercentage',
      'topPoint',
      'getManualPointData',
    ]),
    ...mapGetters(['isTextColourLight', 'isBackstage']),
    ...mapGetters('presentationSetting', ['isShownEmojiAvatar']),
    ...mapGetters('presentationAttributeModule', ['presentationColorPalette']),
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    previousLeaderboard() {
      if (this.isFirstLeaderboard || !this.leaderboardIds) return null
      if (!this.$store.state.leaderboardSoloData) return null
      const currentIndex = this.leaderboardIds.indexOf(this.slideActive.id)
      const prevIndex = currentIndex - 1
      if (prevIndex === -1) return null
      return this.$store.state.leaderboardSoloData[this.leaderboardIds[prevIndex]]
    },
    leaderboardTitle() {
      return 'Leaderboard'
    },
    displayedNumberOfPlayers() {
      if (this.loading) return '…'
      return this.$options.filters.formatNumber(this.rankingListCount)
    },

  },

  watch: {
    '$store.state.slideActive': function watchSlideActive() {
      this.checkShowScroll()
    },
    '$store.state.presentation.filteringProfanity': function oncChangeProfanityFilter() {
      if (!this.filteringProfanity) {
        localStorage.setItem('blockAudiences', JSON.stringify([]))
        this.blockAudiences = []
      }
      this.listAudienceShow.forEach((a) => {
        this.handleSetCensorNameOnProfanity(a)
      })
    },
  },
  mounted() {
    this.getData()
    const self = this
    EventBus.$on('sort-slide', (callback) => {
      self.getData(false, callback)
    })
    EventBus.$on('onKeyboard', self.handleSlideControlsKeydown)

    try {
      if (localStorage.getItem('blockAudiences')) {
        this.blockAudiences = JSON.parse(localStorage.getItem('blockAudiences'))
      }
    } catch (error) {
      this.blockAudiences = []
      Sentry.captureException(error)
    }

    if (this.$store.state.sharePresentation) {
      Util.disallowPDFRender()
    }
  },
  destroyed() {
    EventBus.$off('sort-slide')
    EventBus.$off('onKeyboard', this.handleSlideControlsKeydown)
    if (this.myReq) {
      window.cancelAnimationFrame(this.myReq)
    }
    this.clearTimers()

    document.body.classList.remove('hide-firework')
    Util.allowPDFRender()
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    ...mapActions('leaderboard', [
      'toggleLeaderboardVisibilityAction',
      'getLatestLeaderboardAction',
      'toggleIndividualLeaderboardForTeamplayAction',
    ]),
    handleScrollLeaderboard(e) {
      const listElm = e.target
      if (
        listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight - 50
      ) {
        if (this.listAudienceShow.length < this.topAudiences.length) {
          const from = this.listAudienceShow.length
          let to = from + 9
          if (this.topAudiences.length < to) {
            to = this.topAudiences.length
          }
          const arr = this.topAudiences.slice(from, to)
          this.listAudienceShow = this.listAudienceShow.concat(arr)
        }
      }
    },

    addManualPoints(item) {
      this.addPointData = this.getManualPointData(item)
      if (!this.type) delete this.addPointData.slideId
      this.addPointVisible = true
    },
    addPointOk() {
      this.getData(true)
    },
    addPointClose() {
      this.addPointVisible = false
    },
    canFilterProfanity(item) {
      return typeof (item.isCensorName) !== 'boolean'
    },
    setCensorName(item) {
      if (item.isCensorName) {
        item.censorName = Util.censorName(item.audienceName)
      }
    },
    handleSetCensorNameOnProfanity(audience) {
      let filter = this.presentation.filteringProfanity
      if (!filter) {
        filter = false
      }

      const indexAudienceBlock = this.blockAudiences.findIndex(
        (audienceData) => {
          return audienceData == audience.audience
        },
      )
      if (indexAudienceBlock !== -1) {
        audience.isCensorName = true
        audience.censorName = Util.censorNameLeaderBoard(audience.audienceName)
      } else {
        audience.isCensorName = filter
        if (audience.isCensorName) {
          this.setCensorNameOnProfanity(audience)
          if (!audience.censorName.includes('*')) {
            audience.isCensorName = false
          }
        }
      }
      // if (filter && audience.isCensorName) return
      Util.saveBlockAudience(audience)
    },
    setCensorNameOnProfanity(audience) {
      if (audience.isCensorName) {
        audience.censorName = Util.filterProfaneWordsWrapper(audience.audienceName)
      }
    },
    addCensorName(item) {
      item.isCensorName = !item.isCensorName

      if (item.isCensorName) {
        this.setCensorName(item)
        Util.mixpanelTracking('Presentation Editor', 'Leaderboard > Hide name')
      } else {
        Util.mixpanelTracking('Presentation Editor', 'Leaderboard > Show name')
      }
      this.listAudienceShow.push()
      Util.saveBlockAudience(item)
      this.blockAudiences = JSON.parse(localStorage.getItem('blockAudiences'))
    },

    checkCurrentScore() {
      let check = false

      this.topAudiences.forEach((item) => {
        if (item.oldPoint != item.totalPoint) {
          check = true
        }
      })
      return check
    },
    async getData(reload, callback) {
      this.loading = true
      if (!this.$store.state.swapLeaderboard) {
        EventBus.$emit('leaderboard-loaded', false)
      }
      this.noData = false
      this.finalSlide = false
      this.closeWinnerCarousel()
      this.animation = false

      if (this.myReq) {
        window.cancelAnimationFrame(this.myReq)
      }

      const { slides } = this.presentation

      const slidesQuiz = slides.filter((item) => {
        return item.type == 'pickAnswer'
      })

      const index = Util.getIndexSlide(slides, this.$store.state.slideActive.id)
      let lastQuizIndex = 0
      if (slidesQuiz.length) {
        lastQuizIndex = Util.getIndexSlide(
          slides,
          slidesQuiz[slidesQuiz.length - 1].id,
        )
      }

      if (index >= lastQuizIndex) {
        this.finalSlide = true
      }

      this.updateSlideActiveAction({
        timestampLeaderboard: new Date().getTime(),
      })

      const slideId = this.$store.state.slideActive.id
      const presentationId = this.presentation.id || this.$route.params.id

      const payloadLeaderboard = {
        presentationId,
        finalSlide: this.finalSlide,
        accessCode: this.presentation.uniqueAccessCode,
        order: this.slideActive.order,
        sharePresentation: this.$store.state.sharePresentation,
        timestampFile: this.slideActive.timestampLeaderboard,
      }

      if (this.$store.state.isAdmin) {
        payloadLeaderboard.sharePresentation = true
      }
      await this.getLatestLeaderboardAction(payloadLeaderboard)
      if (slideId != this.$store.state.slideActive.id) {
        return
      }
      EventBus.$emit('leaderboard-loaded', true)

      if (this.leaderboardData?.audiences?.length) {
        this.leaderboardData?.audiences?.forEach((item, key) => {
          item.oldPercent = 1
          item.color = this.presentationColorPalette[key % this.presentationColorPalette.length]
          this.handleSetCensorNameOnProfanity(item)
        })
      } else {
        this.noData = true
      }
      if (this.leaderboardData?.teams?.length) {
        this.leaderboardData?.teams?.forEach((item) => {
          item.oldPercent = 1
          item.color = this.getTeamColor(item)
          item.members = this.leaderboardData?.audiences?.filter((au) => {
            return au.audienceTeam === item.id
          })
        })
      }
      if (!this.leaderboardData.totalAudiences) this.leaderboardData.totalAudiences = 0
      this.topAudiences = this.rankingList
      // if (!this.$store.state.leaderboardSoloData) {
      //   this.$store.state.leaderboardSoloData = {}
      // }
      // this.$store.state.leaderboardSoloData[this.slideActive.id] = this.topAudiences
      this.topWinnerStr = this.leaderboardData.topAudienceStr
      this.countWinner = this.leaderboardData.countWinner

      if (this.leaderboardData.lastName) {
        if (this.countWinner == 2) {
          this.topWinnerStr =
                  `${this.topWinnerStr
                  } ${
                    this.$t('and')
                  } ${
                    this.leaderboardData.lastName}`
        } else if (this.countWinner > 2) {
          this.topWinnerStr =
                  `${this.topWinnerStr
                  }, ${
                    this.$t('and')
                  } ${
                    this.leaderboardData.lastName}`
        }
      }

      if (this.topWinnerStr?.length) {
        const timeRunBanner =
                25 + parseInt(this.topWinnerStr.length / this.minNumberOfDisplayedPlayer, 10)
        this.timeRunbanner = `marquee ${timeRunBanner}s linear infinite`
      } else {
        this.timeRunbanner = 'marquee 25s linear infinite'
      }
      this.topAudiences?.push()
      this.loading = false
      this.animation = true
      const self = this
      let timeWait = 4000
      if (this.isNextLeaderboard) {
        timeWait = 4500
      }
      if (!this.checkCurrentScore()) {
        timeWait = 0
      }
      this.timeOut1 = setTimeout(() => {
        this.topAudiences.forEach((item, key) => {
          item.oldPercent = (item.totalPoint / this.topAudiences[0].totalPoint) * 100
          if (!item.oldPercent) {
            item.oldPercent = 1
          }

          if (key >= this.minNumberOfDisplayedPlayer) {
            item.oldPoint = item.totalPoint
          }
        })

        this.timeOut2 = setTimeout(() => {
          if (this.$store.state.sharePresentation) {
            setTimeout(() => {
              Util.allowPDFRender()
            }, 2000)
          }
          if (
            this.finalSlide &&
                  this.topAudiences.length &&
                  this.topAudiences[0].totalPoint
          ) {
            this.showCarousel = true
            this.showWinner = true
            const canvas = document.getElementById('firework-canvas')
            if (!canvas) return
            canvas.confetti =
                    canvas.confetti ||
                    confetti.create(canvas, {
                      resize: true,
                    })
            const colors = Constant.colorsHex.filter((item, key) => {
              return item && key < this.minNumberOfDisplayedPlayer
            })

            const _startFirework = function () {
              if (self.$store.state.isScreenCapture) return
              let start = null
              let count = 0
              let timeFirework = 250
              // eslint-disable-next-line
                    function step(timestamp) {
                if (count == 3) {
                  timeFirework = 800
                }
                if (!start) start = timestamp
                const progress = timestamp - start
                if (progress > timeFirework) {
                  start = null
                  count++
                  canvas.confetti({
                    startVelocity: 5,
                    spread: 360,
                    ticks: 200,
                    decay: 0.98,
                    particleCount: 80,
                    shapes: ['circle'],
                    colors,
                    zIndex: 100,
                    origin: {
                      x: Math.random(),
                      // since they fall down, start a bit higher than random
                      y: Math.random() - 0.3,
                    },
                  })
                }
                self.myReq = window.requestAnimationFrame(step)
              }
              self.myReq = window.requestAnimationFrame(step)
            }
            this.timeOut3 = setTimeout(() => {
              _startFirework(false)
              this.timeOut3 = null
            }, 500)
            let countCharactorMemberWinner = ''
            if (this.topAudiences[0].members) {
              this.topAudiences[0].members.forEach((mem, key) => {
                countCharactorMemberWinner += mem.audienceName
                if (key !== this.topAudiences[0].members.length - 1) {
                  countCharactorMemberWinner += ' '
                }
              })
            }
            if (countCharactorMemberWinner.length > 150) {
              this.fontSizeMemberWinner = 'size-1'
            }
            if (countCharactorMemberWinner.length > 200) {
              this.fontSizeMemberWinner = 'size-2'
            }
            if (countCharactorMemberWinner.length > 250) {
              this.fontSizeMemberWinner = 'size-3'
            }
            if (countCharactorMemberWinner.length > 300) {
              this.fontSizeMemberWinner = 'size-4'
            }
            if (countCharactorMemberWinner.length > 350) {
              this.fontSizeMemberWinner = 'size-5'
            }
            if (countCharactorMemberWinner.length > 400) {
              this.fontSizeMemberWinner = 'size-6'
            }
          }
          this.timeOut2 = null
        }, timeWait)
        this.timeOut1 = null
        this.checkShowScroll()
      }, 200)

      this.prepareRankingListToShow()

      this.$store.state.lastViewLeaderboardId = this.slideActive.id
      if (callback) {
        callback()
      }

      if (index <= lastQuizIndex) {
        document.body.classList.add('hide-firework')
      }

      this.updateTeamData()
    },
    prepareRankingListToShow() {
      if (!this.rankingList || !this.rankingList.length) return
      const arrAudiences = []
      for (let i = 0; i < this.rankingList.length; i++) {
        if (i < this.minNumberOfDisplayedPlayer) {
          arrAudiences.push(this.rankingList[i])
        } else {
          this.rankingList[i].oldPoint = this.rankingList[i].totalPoint
        }
      }

      arrAudiences.sort(this.audienceSorter)
      if (this.isFirstLeaderboard || !this.isNextLeaderboard || this.rankingList.length > 200) {
        // show the leaderboard without animation from previous leaderboard (because we dont have prev leaderboard)
        // if there're >200 audience, do not animate
        this.listAudienceShow = arrAudiences
        this.isShowIndex = true
      } else {
        // show the leaderboard with animation, transition from prev leaderboard to the new leaderboard
        this.listAudienceShow = this.getLeaderboardToBeAnimated(this.rankingList, this.previousLeaderboard)

        if (this.isLeaderboardRankChange(this.topAudiences, this.previousLeaderboard)) {
          setTimeout(() => {
            this.listAudienceShow = arrAudiences
            // show the index after rearranging the leaderboard
            setTimeout(() => {
              this.isShowIndex = true
            }, 500)
          }, 2500)
        } else {
          this.isShowIndex = true
          this.listAudienceShow = arrAudiences
        }
      }
    },
    checkShowScroll() {
      setTimeout(() => {
        const container = this.$refs[LEADERBOARD_RANKING_LIST_REF]
        this.scrollShow = container && container.scrollHeight > container.clientHeight
      })
    },
    handleSlideControlsKeydown(e) {
      if (this.$store.getters.isPresenting) {
        if (e.code == 'ArrowDown') {
          this.scrollBottom()
        } else if (e.code == 'ArrowUp') {
          this.scrollTop()
        }
      }
      if (config.EXIT_KEYS.includes(e.code)) {
        this.closeLeaderboard()
      }
      if (e.code == 'KeyW') {
        this.toggleWinnerCarousel()
      }
      if (e.code == 'KeyI') {
        this.toggleIndividualLeaderboard()
      }
    },

    toggleIndividualLeaderboard() {
      this.clearTimers()
      this.toggleIndividualLeaderboardForTeamplayAction()
      this.getData()
    },

    scrollBottom() {
      const container = this.$refs[LEADERBOARD_RANKING_LIST_REF]

      if (!container) return

      Util.scrollToElement(container, {
        behavior: 'smooth',
        top: container.scrollTop + 400,
      })

      if (container.scrollTop + container.clientHeight === container.scrollHeight) {
        this.scrollDisable = true
      }
    },
    scrollTop() {
      const container = this.$refs[LEADERBOARD_RANKING_LIST_REF]

      if (!container) return

      this.scrollDisable = false

      Util.scrollToElement(container, {
        behavior: 'smooth',
        top: container.scrollTop - 400 < 0 ? 0 : container.scrollTop - 400,
      })
    },

    closeWinnerCarousel() {
      this.showWinner = false
    },

    openWinnerCarousel() {
      this.showWinner = true
    },
    toggleWinnerCarousel() {
      this.showWinner = !this.showWinner
    },

    getBarColor(item) {
      if (!this.isTeamPlay) {
        return item.color
      }
      if (this.isShowingIndividualLeaderboardForTeamPlay) {
        return this.teams[item.audienceTeam].color || Util.getAhaColorLegacy(item.audienceTeam)
      }
      return item.color
    },

    getTeamColor(team) {
      return team.color || Util.getAhaColorLegacy(team.id)
    },

    getTeamName(item) {
      return (this.teams[item.audienceTeam] && this.teams[item.audienceTeam].name) || this.$t('noTeam')
    },

    updateTeamData() {
      if (!this.presentation.teamData || !this.isTeamPlay) {
        return
      }
      this.presentation.teamData.forEach((team) => {
        this.teams[team.id] = team
      })
    },

    getLeaderboardToBeAnimated(newLeaderboard, oldLeaderboard) {
      if (!newLeaderboard || !oldLeaderboard) return null
      const newLeaderboardMap = Util.fromArrayToMap(newLeaderboard, 'audience')
      oldLeaderboard.sort(this.audienceSorter)
      const audiencesRemoved = oldLeaderboard.filter((item) => {
        return newLeaderboard.map((i) => i.audience).includes(item.audience)
      }).map((item) => {
        return newLeaderboardMap[item.audience]
      })

      const audiencesAdded = newLeaderboard.filter((item) => {
        return !oldLeaderboard.map((i) => i.audience).includes(item.audience)
      })
      const animatingLeaderboard = audiencesRemoved.concat(audiencesAdded)

      return animatingLeaderboard.slice(0, this.minNumberOfDisplayedPlayer)
    },
    isLeaderboardRankChange(newLeaderboard, oldLeaderboard) {
      if (!newLeaderboard || !oldLeaderboard) return false
      const oldIds = oldLeaderboard.map((i) => i.audience).slice(0, this.minNumberOfDisplayedPlayer)
      const newIds = newLeaderboard.map((i) => i.audience).slice(0, this.minNumberOfDisplayedPlayer)
      return JSON.stringify(oldIds) !== JSON.stringify(newIds)
    },
    audienceSorter(a, b) {
      if (a.index < b.index) return -1
      if (a.index > b.index) return 1
      if (a.audienceName < b.audienceName) return 1
      if (a.audienceName > b.audienceName) return -1
      return 0
    },
    closeLeaderboard() {
      this.toggleLeaderboardVisibilityAction({
        isVisible: false,
        presentation: this.presentation,
      })
    },
    clearTimers() {
      if (this.timeOut1) {
        window.clearTimeout(this.timeOut1)
        this.timeOut1 = null
      }
      if (this.timeOut2) {
        window.clearTimeout(this.timeOut2)
        this.timeOut2 = null
      }
      if (this.timeOut3) {
        window.clearTimeout(this.timeOut3)
        this.timeOut3 = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
@import "@/assets/scss/animation.scss";
$leaderboard-max-height: 300px;

.full-size {
  width: 100%;
  height: 100%;
}

.bar--name {
  width: 100%;
  margin: 8px 0;
}

.player-name {
  line-height: 30px;
}

.team-name {
  font-size: 20px;
  font-weight: normal;
  line-height: 20px;
}

.arrow-grid {
  z-index: 4;
}

.arrow-down {
  position: relative;
  top: -11px;
}

.close-icon {
  position: absolute;
  top: 3px;
  right: 8px;
  opacity: 0.5;

  &:hover {
    opacity: 1;
  }
}

.player-name__text {
  max-width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: top;

  .bar--emoji {
    font-size: 1.6rem;
    vertical-align: middle;
  }
}

.button-voice {
  display: inline-block;
  position: relative;
  top: -3px;
  left: 3px;

  &::v-deep {
    .button-video-call {
      height: 38px;
      line-height: 37px;
      padding: 0 12px;
      margin-left: 2px;
    }
  }
}

.leaderboard-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 3;
  .light & {
    background: rgba(0, 0, 0, 0.4);
  }
}

.leaderboard-close {
  position: absolute;
  right: 1rem;
  top: 1rem;
}

.leaderboard-popup {
  position: relative;
  width: calc(100% - 130px * 2);
  height: calc(100% - 160px);
  border-radius: 1rem;
  margin: 94px auto;
  z-index: 4;
  padding-top: 2rem;
  padding-bottom: 2rem;

  backdrop-filter: blur(10px);
  border: 1px solid #3F4557;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;

  .light & {
    color: #333;
    border: 1px solid #d3d7e1;
    background-color: rgba(255, 255, 255, 0.8);
  }

}

.audience--rank-circle {
  position: absolute;
  min-width: 36px;
  min-height: 36px;
  border-radius: 50%;
  top: -3px;
  right: 0;
  left: -1.5px;
  background-color: rgba(255, 255, 255, 0.1);
  .light & {
    @apply  text-base-80;
    background-color: rgba(0, 0, 0, 0.1)
  }
}

.audience--rank-text {
  padding: 10px;
  @apply text-base-0;

  .light & {
    @apply text-base-80;
  }
}

.leaderboard-ranking-list {
  overflow-x: hidden;
  scrollbar-width: none;
  max-height: $leaderboard-max-height;
  margin-bottom: 0.5rem;

}

.team-member {
  font-size: 1.2rem;
  line-height: 1.2rem;
  font-weight: normal;
}

.leaderboard-wrap-v2 {
  // position: relative;
  .box-audience-list {
    width: 100%;
  }

  .top-audience {
    padding: 0 40px;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch; //Chrome
    -ms-overflow-style: auto;
    overflow: -moz-scrollbars-none; //Firefox
    position: relative;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .no-data {
    text-align: center;
    margin-top: 15%;
    height: 100%;
  }

  .audience-name {
    width: 380px;
    padding-right: 24px;
    font-size: 28px;
    text-align: right;
    font-weight: bold;

    .div-name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-right: 8px;
    }
  }

  .audience-item {
    padding: 8px 0;
  }

  .point-progess {
    width: 100%;
  }

  .point-width {
    height: 50px;
    border: 1px solid #fff;
    border-radius: 4px;

    &.animation {
      transition: 2.2s ease-in-out;
    }
  }

  .point-progess {
    height: 50px;
  }

  .audience-result {
    width: 100%;
    font-weight: normal;
    font-size: 25px;
    position: relative;

    .audience-point-total {
      position: absolute;
      right: -112px;
      top: 5px;
      width: 100px;
      display: block;
      font-weight: bold;

      .short-cut-text {
        font-weight: normal;
        margin-left: 1px;
      }
    }
  }

  .audience-point {
    padding-right: 264px;
  }

  .leaderboard--content {
    width: 100%;
    height: 100%;

    .top-audience {
      width: 100%;

      .audience--item {
        padding: 8px 0 5px;
        width: 100%;
      }
    }
  }

  .audience--item {
    margin-bottom: 8px;
  }

  .audience--rank {
    font-size: 22px;
    text-align: right;
    margin-right: 24px;
    min-width: 120px;
    opacity: 0;
    transition: opacity 0.3s ease;

    &.visible {
      opacity: 1;
    }

    .audience--rank-wrapper {
      position: relative;
      width: 100%;
    }
  }

  .audience--bar {
    background-color: rgba(49, 49, 49, 0.1);
    height: auto;
    min-height: 52px;
    min-width: calc(100% - 300px);
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    max-width: 100%;

    &.dark-theme {
      background-color: rgba(255, 255, 255, 0.05);
    }

    .audience--bar-progress {
      height: 100%;
      border-radius: 4px;
      background-color: rgb(78, 170, 241);
      transition: width 2.2s ease-in-out;
      position: absolute;
      top: 0px;
      z-index: 1;

      &.layer--2 {
        border: 2px solid #ffffff;
        overflow: hidden;
      }

      &.has-leaderboard-swap {
        transition: width 1.5s ease-in-out;
      }
    }

    .audience--bar-info {
      white-space: unset;
      word-break: break-word;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 24px;

      .team-name {
        white-space: nowrap;
      }

      &.layer--1 {
        z-index: 3;
        width: 620px;

        .bar--name {
          color: #ffffff;
          cursor: pointer;
        }
      }

      &.layer--3 {
        z-index: 1;
        border: 2px solid transparent;

        .bar--name {
          color: inherit;
        }
      }
    }

    .action {
      margin-left: 5px;
      position: absolute;
      white-space: nowrap;
      font-size: 55%;
      text-transform: uppercase;
      ;
      display: inline-block;
      visibility: hidden;
      animation: fadeInShow 0.3s;
    }

    cursor: pointer;

    &:hover {
      .action {
        visibility: visible;

        span {
          opacity: 0.8;

          &:hover {
            opacity: 1;
          }
        }
      }
    }
  }

  .audience--points {
    font-size: 25px;
    padding-left: 16px;
    min-width: 280px;

    .points-gain {
      margin-bottom: 2px;
      opacity: 0.4;
      font-size: 20px;
    }
  }

  .arrow-grid {
    text-align: center;
    font-size: 32px;
    height: 31px;

    i {
      cursor: pointer;

      &.disabled {
        color: #888;
      }

      &:hover {
        color: #666;
      }
    }
  }

  .quiz--result {
    font-size: 30px;
  }

  .quiz--result-desc {
    font-size: 21px;
  }

  @-webkit-keyframes fadeInLeft {
    from {
      opacity: 0;
      transform: translate3d(-80%, 0, 0);
    }

    to {
      opacity: 0.3;
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes fadeInLeft {
    from {
      opacity: 0;
      transform: translate3d(-80%, 0, 0);
    }

    to {
      opacity: 0.3;
      transform: translate3d(0, 0, 0);
    }
  }

  @-webkit-keyframes fadeInLeftScore {
    from {
      opacity: 0;
      transform: translate3d(-80%, 0, 0);
    }

    to {
      opacity: 0.3;
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes fadeInLeftScore {
    from {
      opacity: 0;
      transform: translate3d(-80%, 0, 0);
    }

    to {
      opacity: 0.3;
      transform: translate3d(0, 0, 0);
    }
  }

  .lb-fadeInLeft {
    animation-name: fadeInLeftScore;
    animation-iteration-count: 1;
    animation-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  }

  @for $i from 1 to 10 {
    .box-audience-wrapper .audience--item:nth-child(#{$i}) .audience--points:nth-child(3) .points-gain:nth-child(2) {
      animation-delay: #{0.5 + ($i * 0.2)}s;
    }
  }
}

</style>
